import React, { useState } from 'react';
import styles from './CopyUrlButton.module.css';

const CopyUrlButton = ({ episode }) => {
  const [copySuccess, setCopySuccess] = useState(false);

  const hasAudio = episode.audio_files && episode.audio_files.length > 0;

  const handleCopyUrl = async () => {
    if (!hasAudio) return;
    
    try {
      const audioUrl = episode.audio_files[0].audio_url;
      await navigator.clipboard.writeText(audioUrl);
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000);
    } catch (error) {
      console.error('Failed to copy URL:', error);
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = episode.audio_files[0].audio_url;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000);
    }
  };

  if (!hasAudio) {
    return null;
  }

  return (
    <button 
      className={styles.copyButton}
      onClick={handleCopyUrl}
      title={copySuccess ? "URL copied!" : "Copy Audio URL"}
    >
      {copySuccess ? "✓" : "📋"}
    </button>
  );
};

export default CopyUrlButton;
